// Stub API service for compatibility
export default {
    discounts: {
        listV2: () => Promise.resolve({ data: { discounts: [] } }),
    },
    orders: {
        export: (queryObject) => Promise.resolve({
            data: {
                data: 'base64data',
                file_name: 'orders.csv',
                type: 'text/csv'
            }
        }),
        getMacrosForState: (orderId) => Promise.resolve({
            data: { macros: [] }
        }),
        runMacro: (orderId, macroId) => Promise.resolve({
            data: { success: true }
        }),
        capturePaymentCustomAmount: (orderId, amount) => Promise.resolve({
            data: { success: true }
        }),
    },
};
//# sourceMappingURL=api.js.map